<template>
  <div class="bbr-settings--audit-log">
    <main-app-bar>
      <template v-slot:title>
        Audit Log
        <span class="caption grey--text ml-2"
          >All times are displayed in UTC</span
        >
      </template>
      <template v-slot:actions>
        <v-btn text @click="showFilters = !showFilters">
          <v-icon left>{{ icons.filter }}</v-icon>
          Filter
        </v-btn>
      </template>
    </main-app-bar>

    <div class="mt-5 px-10 pb-6">
      <!-- Filter Panel -->
      <v-expand-transition>
        <v-card v-if="showFilters" class="mb-6 pa-4" outlined>
          <v-row>
            <v-col cols="2">
              <v-autocomplete
                v-model="filterForm.causer_id"
                :items="admins"
                item-text="full_name"
                item-value="id"
                label="User"
                clearable
                dense
                outlined
                hide-details
              />
            </v-col>
            <v-col cols="2">
              <v-select
                v-model="filterForm.subject_type"
                :items="subjectTypes"
                item-text="label"
                item-value="value"
                label="Entity Type"
                clearable
                dense
                outlined
                hide-details
              />
            </v-col>
            <v-col cols="2">
              <v-select
                v-model="filterForm.source"
                :items="sourceOptions"
                item-text="label"
                item-value="value"
                label="Log Source"
                clearable
                dense
                outlined
                hide-details
              />
            </v-col>
            <v-col cols="2">
              <v-menu
                v-model="dateFromMenu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="filterForm.date_from"
                    label="Date From"
                    readonly
                    clearable
                    dense
                    outlined
                    hide-details
                    v-bind="attrs"
                    v-on="on"
                  />
                </template>
                <v-date-picker
                  v-model="filterForm.date_from"
                  @input="dateFromMenu = false"
                />
              </v-menu>
            </v-col>
            <v-col cols="2">
              <v-menu
                v-model="dateToMenu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="filterForm.date_to"
                    label="Date To"
                    readonly
                    clearable
                    dense
                    outlined
                    hide-details
                    v-bind="attrs"
                    v-on="on"
                  />
                </template>
                <v-date-picker
                  v-model="filterForm.date_to"
                  @input="dateToMenu = false"
                />
              </v-menu>
            </v-col>
            <v-col cols="2" class="d-flex align-center">
              <v-btn
                color="primary"
                depressed
                small
                class="mr-2"
                @click="applyFilter"
              >
                Apply
              </v-btn>
              <v-btn text small @click="resetFilter"> Reset </v-btn>
            </v-col>
          </v-row>
        </v-card>
      </v-expand-transition>

      <!-- Log List -->
      <audit-log-table
        :list="list"
        :loading="loading"
        :list-meta="listMeta"
        @loadMore="loadMore"
      />
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import { mdiFilterVariant } from '@mdi/js'
import MainAppBar from '@/layouts/shared/MainAppBar'
import AuditLogTable from './components/AuditLogTable'

export default {
  name: 'AuditLogPage',

  components: {
    MainAppBar,
    AuditLogTable,
  },

  data() {
    return {
      loading: false,
      showFilters: false,
      dateFromMenu: false,
      dateToMenu: false,
      icons: {
        filter: mdiFilterVariant,
      },
      sourceOptions: [
        { label: 'Auto', value: 'auto' },
        { label: 'Manual', value: 'manual' },
      ],
      filterForm: {
        causer_id: null,
        subject_type: null,
        source: null,
        date_from: null,
        date_to: null,
      },
    }
  },

  computed: {
    ...mapState({
      list: (state) => state.activityLogs.list,
      listMeta: (state) => state.activityLogs.listMeta,
      admins: (state) => state.activityLogs.admins,
      subjectTypes: (state) => state.activityLogs.subjectTypes,
    }),
  },

  created() {
    this.getAdmins()
    this.getSubjectTypes()
    this.fetchData()
  },

  destroyed() {
    this.clearList()
    this.resetStoreFilter()
  },

  methods: {
    ...mapActions({
      getDataList: 'activityLogs/getDataList',
      getAdmins: 'activityLogs/getAdmins',
      getSubjectTypes: 'activityLogs/getSubjectTypes',
    }),

    ...mapMutations({
      clearList: 'activityLogs/clearList',
      setFilter: 'activityLogs/setFilter',
      resetStoreFilter: 'activityLogs/resetFilter',
    }),

    async fetchData(page = 1) {
      this.loading = true
      await this.getDataList({ page })
      this.loading = false
    },

    loadMore() {
      if (this.listMeta.current_page < this.listMeta.last_page) {
        this.fetchData(this.listMeta.current_page + 1)
      }
    },

    applyFilter() {
      this.setFilter({ ...this.filterForm })
      this.clearList()
      this.fetchData()
    },

    resetFilter() {
      this.filterForm = {
        causer_id: null,
        subject_type: null,
        source: null,
        date_from: null,
        date_to: null,
      }
      this.resetStoreFilter()
      this.clearList()
      this.fetchData()
    },
  },
}
</script>
